import { Fragment } from 'react';
import { Divider, Skeleton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const useStyles = makeStyles()((theme) => ({
  container: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    colorScheme: 'dark',
    position: 'relative',
    height: '75vh',
    overflow: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    scrollbarWidth: 'none',
  },
  search: {
    marginTop: 15,
    marginBottom: 35,
  },

  titles: {
    height: 54,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    width: '100%',
  },

  info: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  arrow: {
    color: '#ffffff4d',
  },
}));

const SongbookSkeleton = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.container} data-testid="songbook-skeleton">
      <div>
        <Skeleton variant="rounded" width={380} height={56} className={classes.search} />
      </div>
      <div>
        {Array.from({ length: 10 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={`songbook-skeleton-${index}`}>
            <div className={classes.info}>
              <div>
                <Skeleton variant="circular" width={30} height={30} />
              </div>
              <div className={classes.titles}>
                <Skeleton width="18em" height={30} animation="wave" />
                <Skeleton width="10em" height={20} animation="wave" />
              </div>
              <KeyboardArrowRightIcon className={classes.arrow} />
            </div>
            <Divider sx={{ margin: '0 9px' }} />
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default SongbookSkeleton;
